import { render, staticRenderFns } from "./NovaVenda.vue?vue&type=template&id=67e9946c&scoped=true"
import script from "./NovaVenda.vue?vue&type=script&lang=js"
export * from "./NovaVenda.vue?vue&type=script&lang=js"
import style0 from "./NovaVenda.vue?vue&type=style&index=0&id=67e9946c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e9946c",
  null
  
)

export default component.exports